import React, { ReactNode } from 'react'
import { CommonFormUi } from './ui'
import { FormInterface } from '../../types/entities/form-interface'

export interface CommonFormProps {
  entity: FormInterface
  children: ReactNode
}

export const CommonForm = ({ children, entity }: CommonFormProps) => {
  return (
    <CommonFormUi
      layout={entity.layout}
      border={entity.border}
      mobileBorder={entity.mobileBorder}
      padding={entity.padding}
      mobilePadding={entity.mobilePadding}
      backgroundColor={entity.backgroundColor}
      mobileBackgroundColor={entity.mobileBackgroundColor}
    >
      {children}
    </CommonFormUi>
  )
}
